import { destructive } from '../../../../styles/colors';
import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
	fillColor?: string;
}

export const CancelIcon: React.FC<IProps> = ({ className = '', fillColor = '' }) => {
	return (
		<SvgIcon className={`cancel-icon ${className || ''}`} height={20} width={20}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m0 18C4.486 20 0 15.514 0 10S4.486 0 10 0s10 4.486 10 10-4.486 10-10 10'
				fill={fillColor || destructive}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M14.707 6.706l-1.414-1.414L10 8.585 6.707 5.292 5.293 6.706 8.586 10l-3.293 3.293 1.414 1.415L10 11.413l3.293 3.293 1.414-1.415L11.414 10l3.293-3.293z'
				fill={fillColor || destructive}
			/>
		</SvgIcon>
	);
};
